import React, { useContext, useState } from "react";
import { ButtonProps, ConfirmDialog, FormValidationSummary, ValidationResult } from "sprint-common-web";

import { useCloudFileApi } from "../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { CloudFileListingContext } from "../CloudFileListingContext";

export type RepeatProcessingButtonDialogProps = Pick<ButtonProps, "disabled"> & {
    itemId: string;
    filePath: string;
    onClose(): void;
    isOpen: boolean;
};

export const RepeatProcessingButtonDialog: React.VFC<RepeatProcessingButtonDialogProps> = ({
    itemId,
    filePath,
    isOpen,
    onClose
}: RepeatProcessingButtonDialogProps) => {
    const { repeatCloudFileProcessing, validateIfObjectExists } = useCloudFileApi();

    const { repeatItemProcessing } = useContext(CloudFileListingContext);

    const [validationResult, setValidationResult] = useState<ValidationResult | undefined>();

    const close = () => {
        onClose();
        setValidationResult(undefined);
    };

    const handleConfirmation = async () => {
        const result = await validateAndSetResult();

        if (!result.isValid) {
            return;
        }

        await repeatCloudFileProcessing({ cloudFileId: itemId });

        repeatItemProcessing(itemId);

        close();
    };

    const validateAndSetResult = async () => {
        const result = await validateIfObjectExists({ filePath });

        setValidationResult(result);

        return result;
    };

    return (
        <>
            <ConfirmDialog
                title="Repeat processing"
                text="Are you sure you want to process this file again?"
                hidden={!isOpen}
                confirm={{ onClick: handleConfirmation }}
                cancel={{ onClick: close }}
            >
                <FormValidationSummary validationResult={validationResult} />
            </ConfirmDialog>
        </>
    );
};
